import { ImpactShopProductDisplayAttributes } from "@ecologi/shared";
import CheckIconSvg from "@ecologi/assets/icons/impact-shop/check.svg";
import styled from "@emotion/styled";
import React from "react";

type ImpactShopProductPageBenefitsProps = {
  benefits: ImpactShopProductDisplayAttributes["benefits"];
};

const Container = styled.div`
  margin-top: 32px;

  @media ${({ theme }) => theme.bp.extraWideDesktopUp} {
    margin-top: 64px;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const CheckIcon = styled(CheckIconSvg)`
  margin-right: 16px;
`;

export const ImpactShopProductPageBenefits = ({
  benefits,
}: ImpactShopProductPageBenefitsProps) => {
  if (!benefits) return null;

  return (
    <Container>
      {benefits.map((benefit, i) => (
        <Row key={i}>
          <CheckIcon /> {benefit}
        </Row>
      ))}
    </Container>
  );
};
